
<template>
    <div class="scroll-container">
        <DsListItem
            v-for="element in elements"
            :key="element.cell.id"
            :title="element.displayLabel"
            clickable
            data-qa="automation-element"
            class="custom-list-item"
            @click="$emit('click', element.cell)"
        >
            <template #shortDescription>
                <DsTextHighlighter
                    :content="element.name || ''"
                    :highlight="normalizedQuery"
                />
            </template>

            <template #leading>
                <img
                    class="custom-icon"
                    :src="element.iconSrc"
                    :alt="`${element.cell.type} icon`"
                />
            </template>

            <template #trailing>
                <div class="status-wrapper">
                    <DsStatus
                        :type="element.isBroken ? 'error' : (element.setupRequired ? 'warning' : 'default')"
                        class="no-semi-bold"
                    >
                        {{ element.status }}
                    </DsStatus>
                </div>
            </template>
        </DsListItem>
    </div>
</template>

<script>
export default {
    props: {
        elements: {
            type: Array,
            default: () => ([]),
        },
        query: {
            type: String,
            default: '',
        },
    },
    computed: {
        normalizedQuery() {
            return (this.query || '').trim();
        },
    },
};
</script>

<style lang="scss" scoped>
.scroll-container {
    overflow-y: auto;
    width: 100%;
    display: flex;
    flex-direction: column;
}

::v-deep(.custom-list-item) {
    display: flex;
    align-items: flex-start;
}

::v-deep(.custom-list-item .leading-slot)  {
  align-self: flex-start;
  margin-left:  $spacing-200;
}

::v-deep(.custom-list-item .trailing-slot) {
  align-self: flex-start;
  margin-right: $spacing-200;
}

.custom-icon {
  width: $spacing-250;
  height: $spacing-250;
  margin-top: 0;
  margin-left: $spacing-025;
}
::v-deep(.border-partial) {
  padding-left: 0;
  padding-right: 0;
}
::v-deep(.border-partial .list-item-info) {
  padding-left: 0;
  padding-right: 0;
  padding-bottom: $spacing-200;
}
::v-deep(.custom-list-item .ds-list-item-title),
::v-deep(.custom-list-item .ds-list-item-description) {
  word-break: break-word;
  white-space: normal;
}
.status-wrapper {
  white-space: nowrap;
  text-align: right;
  padding-left: $spacing-100;
  align-self: flex-start;
  max-width: 100%;
  overflow-wrap: normal;
}
::v-deep(.no-semi-bold span) {
  font-size: $spacing-150;
  line-height: $spacing-200;
  font-weight: 700;
  color: $color-ink-700;
  letter-spacing: 0;
}
.custom-list-item {
  --text-highlighter-matching-color: #000;
  --text-highlighter-matching-weight: 700;
}
</style>
